
//注册
export const REG_STATE = 'reg_state'

//聊天切换模式
export const CHAT_STATE = 'chat_state'

//好友列表
export const FRIEND_LIST = 'friend_list'

//设置当前选中的聊天对象
export  const SET_CURRENT = 'set_current'

//消息列表
export const MSG_LIST = 'msg_list'
